<script>
import FilePreView from '@/components/FilePreview/FilePreview'
const StepIcon = {
  name: 'StepIcon',
  functional: true,
  render(h, context) {
    const props = { ...context.data }
    return (
      <div class={'stage-element'}>
        {props.status == 'finish' ? (
          <div class={'stage-icon--finish'}>{props.icon}</div>
        ) :props.status == 'active' ? (
          <div class={'stage-icon--active'}>{props.icon}</div>
        ): (
          <div class={'stage-icon'}>{props.icon}</div>
        )}
        <div class="stage-text">{props.span}</div>
        {props.description && (
          <div class="stage-description">{props.description}</div>
        )}
        {props.uri && (
          <FilePreView  id={props.uri} viewFileName= {'查看'+props.span.substring(2)} styleType = '1' />
        )}
      </div>
    )
  },
}
const StepLine = {
  name: 'StepLine',
  functional: true,
  render(h, context) {
    const props = { ...context.data }
    const lineStatus = () => {
      if (props.icon == 1) {
        return null
      } else {
        if (props.status == 'finish') {
          return (
            <div>
              <div class={'stage-linetime'}>{props.time}</div>
              <div class={'stage-line--finish'}></div>
            </div>
          )
        }else if(props.status == 'active'){
          return <div class={'stage-line--active'}></div>
        } else {
          return <div class={'stage-line'}></div>
        }
      }
    }
    return lineStatus()
  },
}

export default {
  name: 'Step-container',
  mounted() {},
  props: {
    arr: {
      type: Array,
      default: [],
    },
  },
  render() {
    let data = this.arr
    return (
      <div class={'pt-5'}>
        <div class={'stage-element-box'}>
          {data.map((i) => {
            return (
              <div class={'stage-element' + ' stage-element-' + i.status}>
                <StepIcon {...i} />
                <StepLine {...i} />
              </div>
            )
          })}
        </div>
      </div>
    )
  },
}
</script>
<style lang="scss">
.stage-element-box {
  color: #333;
  fonr-size: 16px;
  font-weight: 600;
  width: 100%;
  display: flex;
  text-align: center;
  .stage-text {
    margin-top: 10px;
  }
  .stage-description {
    margin-top: 10px;
    font-size: 14px;
    font-weight: normal;
  }
  .stage-element {
    position: relative;
    flex: 1;
    // &-finish {
    //   & + .stage-element-wait {
    //     .stage-line {
    //       background-color: #3b85f4;
    //     }
    //     .stage-icon {
    //       font-weight: bold;
    //     }
    //   }
    // }
  }
  .stage-icon {
    display: block;
    width: 20px;
    height: 20px;
    line-height: 20px;
    margin: 0 auto 4px;
    border-radius: 50%;
    position: relative;
    background: #cccccc 100%;
    z-index: 99;
    color: #ffffff;
    text-align: center;
  }
  .stage-icon--finish {
    display: block;
    width: 20px;
    height: 20px;
    line-height: 20px;
    margin: 0 auto 4px;
    border-radius: 50%;
    position: relative;
    background: #3b85f4 100%;
    z-index: 99;
    color: #ffffff;
    text-align: center;
  }
  .stage-icon--active {
    display: block;
    width: 20px;
    height: 20px;
    line-height: 20px;
    margin: 0 auto 4px;
    border-radius: 50%;
    position: relative;
    background: #3f4041 100%;
    z-index: 99;
    color: #ffffff;
    text-align: center;
  }

  .stage-line {
    position: absolute;
    top: 8px;
    right: 68%;
    width: 60%;
    height: 6px;
    z-index: 1;
    background-color: #e4e4e4;
    border-radius: 3px;
  }
  .stage-line--finish {
    position: absolute;
    top: 8px;
    right: 68%;
    width: 60%;
    height: 6px;
    z-index: 1;
    background-color: #3b85f4;
    border-radius: 3px;
  }
  .stage-line--active {
    position: absolute;
    top: 8px;
    right: 68%;
    width: 60%;
    height: 6px;
    z-index: 1;
    background-color: #3b85f4;
    border-radius: 3px;
  }
  .stage-linetime {
    position: absolute;
    right: 48%;
    width: 100%;
    top: -16px;
    color: 12px;
    font-weight: 0;
  }
}
</style>
